import { useState, useEffect, useCallback } from "react";
import axios from "axios";

export const useComunicaPJe = (numeroProcesso, dataNotificacao, aberto) => {
  const [textoComunicacao, setTextoComunicacao] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const buscarComunicacao = useCallback(async () => {
    if (!aberto || !numeroProcesso) {
      setTextoComunicacao("");
      return;
    }

    setLoading(true);
    setError(null);
    setTextoComunicacao("Carregando comunicação do ComunicaPJe...");

    let dataFormatada = "";
    if (dataNotificacao) {
      dataFormatada = String(dataNotificacao).split("T")[0];
    }

    const numLimpo = numeroProcesso.replace(/\D/g, "");

    try {
      // Chamada direta do navegador para a API do ComunicaPJe (sem passar pelo Render)
      const response = await axios.get("https://comunicaapi.pje.jus.br/api/v1/comunicacao", {
        params: {
          numeroProcesso: numLimpo,
          dataDisponibilizacaoInicio: dataFormatada,
          dataDisponibilizacaoFim: dataFormatada,
        },
      });

      const resultados = response.data?.items || response.data?.content || response.data || [];

      if (Array.isArray(resultados) && resultados.length > 0) {
        const textoEncontrado = resultados
          .map((item) => item.texto || item.conteudo || "")
          .filter(Boolean)
          .join("\n\n---\n\n");

        setTextoComunicacao(
          textoEncontrado || "Nenhum texto retornado para esta comunicação."
        );
      } else {
        setTextoComunicacao(
          "Nenhuma comunicação encontrada para este processo na data especificada."
        );
      }
    } catch (err) {
      console.error("Erro na busca direta do ComunicaPJe:", err);
      setError("Falha ao carregar a comunicação processual.");
      setTextoComunicacao("Erro ao buscar informações na API ComunicaPJe.");
    } finally {
      setLoading(false);
    }
  }, [numeroProcesso, dataNotificacao, aberto]);

  useEffect(() => {
    buscarComunicacao();
  }, [buscarComunicacao]);

  return { textoComunicacao, loading, error, refetch: buscarComunicacao };
};